import type { UserTenant } from '../services/api'
import { navigateToTenantPortal } from '../config/api'

interface TenantSelectorProps {
  tenants: UserTenant[]
  userName?: string
}

export default function TenantSelector({ tenants, userName }: TenantSelectorProps) {
  const handleSelectTenant = (slug: string) => {
    // Navigate to tenant portal using subdomain
    navigateToTenantPortal(slug)
  }

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="bg-gray-800 rounded-card shadow-2xl max-w-lg w-full p-8">
        {/* Header - Updated with Jarix branding */}
        <div className="text-center mb-8">
          {/* Logo */}
          <div className="flex justify-center mb-4">
            <img
              src="/favicon.png"
              alt="Jarix"
              className="w-12 h-12"
            />
          </div>
          <h1 className="font-heading text-2xl font-semibold text-white mb-2 tracking-tight">
            <span className="text-jarix-coral">Jarix</span> Security Portal
          </h1>
          {userName && (
            <p className="text-gray-400 font-sans">
              Hola, <span className="text-white">{userName}</span>
            </p>
          )}
          <p className="text-gray-500 text-sm mt-2 font-sans">
            Selecciona el cliente al que deseas acceder
          </p>
        </div>

        {/* Tenant List */}
        <div className="space-y-3">
          {tenants.map((tenant) => (
            <button
              key={tenant.id}
              onClick={() => handleSelectTenant(tenant.slug)}
              className="w-full bg-gray-700/50 hover:bg-gray-700 border border-gray-600 hover:border-jarix-coral rounded-card-sm p-4 transition-all duration-200 group text-left"
            >
              <div className="flex items-center gap-4">
                {/* Tenant Color Indicator */}
                <div
                  className="w-12 h-12 rounded-button flex items-center justify-center text-white font-heading font-semibold text-lg"
                  style={{ backgroundColor: tenant.primary_color || '#FF9B71' }}
                >
                  {tenant.name.charAt(0).toUpperCase()}
                </div>

                {/* Tenant Info */}
                <div className="flex-1">
                  <h3 className="text-white font-semibold group-hover:text-jarix-coral transition-colors font-heading">
                    {tenant.name}
                  </h3>
                  <p className="text-gray-500 text-sm font-sans">
                    {tenant.tenant_role === 'admin' ? 'Administrador' : 'Visualizador'}
                  </p>
                </div>

                {/* Arrow */}
                <svg
                  className="w-5 h-5 text-gray-500 group-hover:text-jarix-coral group-hover:translate-x-1 transition-all"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </div>
            </button>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-8 pt-6 border-t border-gray-700 text-center">
          <p className="text-gray-500 text-sm font-sans">
            {tenants.length} {tenants.length === 1 ? 'cliente disponible' : 'clientes disponibles'}
          </p>
        </div>
      </div>
    </div>
  )
}
